<template lang="pug">
.relative
  slot(name="legend" :legends="legends")
    div
  canvas(ref="canvas")
  slot(name="tooltip" :tooltip="tooltip")
    table-tooltip(v-if="tooltip.shown" :title='tooltip.title' :rows='tooltip.rows')
</template>
<script>
import { toRefs } from 'vue'
import useOptions from './composables/useOptions'
import useDatasets from './composables/useDatasets'
import useCreateChart from './composables/useCreateChart'
import useTreemapTooltip from './composables/useTreemapTooltip'
import useCustomLegend from './composables/useCustomLegend'

export default {
  props: {
    /**
     * Array of data eg. [{date: '2020-01-01', fund: '105', benchmark: '102'}, ...]
     */
    data: {
      type: Array,
      default: () => [],
    },
    /**
     * Metadata
     */
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const { data, options } = toRefs(props)

    const { tooltip, tooltipOptions } = useTreemapTooltip()
    const { legends } = useCustomLegend()
    const { chartOptions } = useOptions(options, { tooltip: tooltipOptions, legends })
    const { datasets, labels } = useDatasets(data, options, {}, { multicolor: true })
    const { canvas } = useCreateChart({ type: 'treemap', datasets, labels, chartOptions })

    return {
      canvas,
      tooltip,
      legends,
    }
  },
}
</script>
